import {BookingConfirmationView} from "./bookingConfirmationView";
import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {Router} from "@/rawdogjs/src/router";

export class BookingConfirmationPresenter implements IPresenter {

    public _view: BookingConfirmationView;
    private dependencyContainer: ParcelDependencyContainer;
    private _router: Router;

    constructor(homeView: BookingConfirmationView, router: Router, dependencyContainer: ParcelDependencyContainer) {
        this._view = homeView;
        this.dependencyContainer = dependencyContainer;
        this._router = router;
    }

    async initialize() {
        this._view.bind(this, async () => {
        });

        this._view.scrollToTop();
    }

    inject() {
    }

}

